var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"player"}},[_c('plyr',{ref:"plyr",staticClass:"plyr--video"},[_c('video',{attrs:{"crossorigin":"","playsinline":""}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }